export default __webpack_public_path__ + "static/media/rss1.71f59e1b.PNG";